/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-useless-escape */
import React from 'react';
import { connect } from 'react-redux';
import page from '@/layouts/page';
import Head from '@/componentWebs/head';
import dynamic from 'next/dynamic';
import moment from 'moment';
import ComboComponent from '@/componentWebs/vietnamTickets/ComboComponent';
import ProvincesTabs from '@/componentWebs/vietnamTickets/ProvincesTabs';
// import ProvincesCarosel from '@/componentWebs/Common/ProvincesCarosel';
import BoxSearchProvinces from '@/componentWebs/vietnamTickets/BoxSearchProvinces';
import { Spin } from 'antd';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';

const BoxSearchFlignhts = dynamic(
  () => import('@/componentWebs/vietnamTickets/BoxSearchFlignhts'),
  {
    ssr: true,
    loading: () => null,
  }
);

@page
@connect(({ webs }) => ({
  webs,
}))
class Detail extends React.Component {
  static async getInitialProps(ctx) {
    const { query } = ctx;
    return {
      query,
    };
  }

  state = {
    key: Math.random(),
    spinning: false,
    data: {},
    isInternationalState: "0",
    textProvinces: "",
    typeInternational: false,
  };

  componentDidMount() {
    const { dataSite, query, dispatch } = this.props;
    this.setState({
      spinning: true,
    });
    dispatch({
      type: 'webs/fetchProvincesDetail',
      payload: {
        id: query.id,
      },
      callback: res => {
        this.setState({
          data: res || {},
          spinning: false,
          key: Math.random(),
          isInternationalState: (res.countries && res.countries.id && Number(res.countries.id)) !== 1 ? '1' : '0',
          textProvinces: res && res.provinceName || ""
        });
      },
    });

  }

  handleInternational = status => {
    this.setState({
      isInternationalState: status,
      typeInternational: true
    });
  };

  render() {
    const { dataSite, query } = this.props;
    const { key, spinning, data, isInternationalState, textProvinces, typeInternational } = this.state;
    // console.log("dataa: ,", data, query);
    const img = data &&
      (data.images &&
        data.images[0] &&
        data.images[0].file &&
        getResponsiveImage(data.images[0].file)) ||
      '';
    const newQuery = {
      province: data.id,
      countries: data && data.countriesId,
      text: `${data.provinceName && data.provinceName + ',' || ''} ${data.countries && data.countries.countrieName || ''}`,
    };
    let styleBg = {
      backgroundImage: `url("${img}")`,
      background: '#eee'
    }
    if (img) {
      delete styleBg.background
    }
    const { province, countries, text } = newQuery;

    let url;
    if (typeof window !== 'undefined') {
      url = window.location.href;
    }
    const ogImage =
      data.images && data.images[0] && data.images[0].file;
    return (
      <React.Fragment>
        <Head
          title={data.provinceName && `Dịch vụ tại ${data.provinceName} - ${dataSite.name}` || 'Dịch vụ'}
          dataSite={dataSite}
          keywords={`Dịch vụ trọn gói giá siêu hấp dẫn tại ${data.provinceName} - ${dataSite && dataSite.seoKeywords}`}
          description={`Dịch vụ trọn gói giá siêu hấp dẫn tại ${data.provinceName} - ${dataSite && dataSite.seoDescriptions}`}
          ogImage={ogImage}
          url={url || ''}
        />
        <Spin spinning={spinning}>
          <div className="banner-province-search">
            <div
              className="bg"
              style={styleBg}
            />
            <div className="text">{data.provinceName && `Dịch vụ trọn gói giá siêu hấp dẫn tại ${data.provinceName
              }`}</div>
          </div>
          <div className="container-normal bannerMobile">
            <BoxSearchProvinces getIsInternational={this.handleInternational} defaultValue={newQuery} key={key} />
          </div>

          <section className="khachSan tour">
            <div className="container-normal">
              {/* <ProvincesCarosel isInternational={countries !== "1" ? "1" :  "0"} /> */}
              <ProvincesTabs
                diaChi={[countries, province]}
                key={key}
                // isInternational={countries !== '1' ? '1' : '0'}
                textCountries={data.countries && data.countries.countrieName}
                typeInternational={(data.countries && data.countries.id && Number(data.countries.id)) !== 1 ? '1' : '0'}
                isInternational={isInternationalState}
                textProvinces={textProvinces}
              />
              {/* Product khach san  */}
            </div>
          </section>
          <div className="pagiTuyenBay-top hidden-pc" />
        </Spin>
      </React.Fragment>
    );
    // }
    // return <Exception style={{ clear: 'both' }} />;
  }
}

export default Detail;
